import { graphql, useMutation } from "react-relay";
import { useChangeTeamMembershipLeaveMutation } from "./__generated__/useChangeTeamMembershipLeaveMutation.graphql";
import { useChangeTeamMembershipJoinMutation } from "./__generated__/useChangeTeamMembershipJoinMutation.graphql";

export function useChangeTeamMembership(teamId: string) {
  const [leave, leaveInFlight] =
    useMutation<useChangeTeamMembershipLeaveMutation>(graphql`
      mutation useChangeTeamMembershipLeaveMutation($teamId: ID!) {
        me {
          leaveTeams(teamIds: [$teamId]) {
            id
            currentStoreUser {
              id
              teams {
                id
              }
            }
          }
        }
      }
    `);

  const [join, joinInFlight] = useMutation<useChangeTeamMembershipJoinMutation>(
    graphql`
      mutation useChangeTeamMembershipJoinMutation($teamId: ID!) {
        me {
          joinTeams(teamIds: [$teamId]) {
            id
            currentStoreUser {
              id
              teams {
                id
              }
            }
          }
        }
      }
    `
  );

  const joinTeam = () => {
    join({ variables: { teamId } });
  };
  const leaveTeam = () => {
    leave({ variables: { teamId } });
  };

  return {
    joinTeam,
    leaveTeam,
    isPending: leaveInFlight || joinInFlight,
  };
}
